module.exports = __webpack_public_path__ + "static/img/hero-fit-red.612edf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero-fit-red.png
// module id = 1099
// module chunks = 173